//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('travExpType', {
//        templateUrl: 'views/components/views/travExpType/travExpType.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'travExpTypeService', 'logisticService', 'typeaheadService', function ($stateParams, stateService, utilityService, translateService, modalService, travExpTypeService, logisticService, typeaheadService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let trexTypeId = $stateParams.trextype_id;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                selectListGlyphicons: [],
//                selectListCompanies: [],
//                glyphiconColour: '',
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE CALLS

//            async function loadEdit() {
//                vm.model.edit = (await travExpTypeService.getTravelExpenceType({ trextype_id: trexTypeId }))[0];
//            }

//            async function loadGlyphicons() {
//                vm.model.selectListGlyphicons = await travExpTypeService.listGlyphicons();
//            }

//            async function loadCompanies() {
//                vm.model.selectListCompanies = await logisticService.listCompanies({ add_all: '0' });
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//            vm.typeaheadSearch = function (value, id) {
//                switch (id) {
//                    case 'account_name':
//                        vm.model.edit[id] = value;

//                        return typeaheadService.lookUpSearchAccounts({
//                            searchtext: vm.model.edit[id] || '',
//                            businessco_no: vm.model.edit.businessco_no
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//            // #region SELECTED VALUE FUNCTION

//            vm.onTypeaheadSelected = function (item, id) {
//                switch (id) {
//                    case 'account_name':
//                        if (item) {
//                            vm.model.edit.account_no = item?.item_id ?? '0';
//                            vm.model.edit.account_name = item?.item_name ?? '';
//                        } else {
//                            vm.onTypeaheadClear('account_name');
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion SELECTED VALUE FUNCTION

//            // #region CHANGED VALUE FUNCTION

//            vm.onTypeaheadChanged = function (value, item, id) {
//                switch (id) {
//                    case 'account_name':
//                        vm.model.edit.account_name = value;

//                        if (value) {
//                            if (item?.item_id) {
//                                vm.model.edit.account_no = item.item_id;
//                            }
//                        } else {
//                            vm.onTypeaheadClear('account_name');
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion CHANGED VALUE FUNCTION

//            // #region CLEAR VALUE FUNCTION

//            vm.onTypeaheadClear = function (id) {
//                switch (id) {
//                    case 'account_name':
//                        vm.model.edit.account_no = '0';
//                        vm.model.edit.account_name = '';
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion CLEAR VALUE FUNCTION

//            // #region SHOW GLYPHICON SYMBOL FUNCTION
            
//            async function showGlyphiconSymbol() {
//                vm.model.selectListGlyphicons.forEach((item) => {
//                    if (vm.model.edit.glyphicon === item.item_id) {
//                        vm.model.edit.glyphicon = item.item_glyphicon;
//                        vm.model.glyphiconColour = item.item_glyphicon_color;
//                    }
//                });
//            }

//            // #endregion SHOW GLYPHICON SYMBOL FUNCTION

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                travExpTypeService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'glyphicon':
//                        if (utilityService.validateWatchValue(value, vm.model.edit.glyphicon) !== true) return;

//                        vm.model.edit.glyphicon = value;

//                        if (utilityService.validateParmsValue(vm.model.edit.glyphicon, true) !== true) return;

//                        showGlyphiconSymbol();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS
            
//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//                loadGlyphicons();
//                loadCompanies();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
